/**
 * NOTE HOST、HOST_M 是在 config 中通过 defineConstants 配置的
 */
/* eslint-disable */
export const baseURL = '/api';

// url——————————————————————————————————————

// 内部接口链接地址
export const UPDATE_ACCOUNT_STATUS_URL = `${baseURL}/freelancer/account/updateFreelancerStatus`; // 账号状态更新
export const QUERY_CONTRACT_SIGN_URL = `${baseURL}/freelancer/contract/queryElectronicSignUrl`; // 查询电子合同签署链接
export const QUERY_CONTRACT_VIEW_URL = `${baseURL}/freelancer/contract/queryElectronicDownloadUrl`; // 查询电子合同查看链接
export const QUERY_SALARY_ORDER_URL = `${baseURL}/freelancer/salary/querySalaryOrderInfo`; // 确认实名信息
export const QUERY_REALNAME_CONFIRM_URL = `${baseURL}/freelancer/account/changeRealNameInfo`; // 确认实名信息
export const QUERY_AKS_SETTINGS_URL = `${baseURL}/freelancer/aks/rSAPublicKeyNByAlias`; // 获取公钥
export const QUERY_CERTIFICATE_INFO_URL = `${baseURL}/freelancer/account/queryCertInfo`; // 获取证件详情
export const QUERY_CERT_CHECK_URL = `${baseURL}/freelancer/account/queryCertCheckUrl`; // 获取证件审核URl
export const SETTLE_STATUS_URL = `${baseURL}/freelancer/account/freelancerInfoCheck`; // 获取入驻状态
export const CHECK_CODE_URL = `${baseURL}/freelancer/account/checkEntId`; // 校验邀请码
export const QUERY_CERTIFICATE_LIST_URL = `${baseURL}/freelancer/contract/queryCertAuditRecord`; // 查询证件审核
export const SWITCH_BINDING_TENANT_URL = `${baseURL}/freelancer/account/switchBindTenantEnt`; // 切换关联渠道商
export const QUERY_TENANT_DOCUMENTS_REVIEW_URL = `${baseURL}/freelancer/account/queryTenantDocumentsReview`; // 查询证件审核状态
export const QUERY_ACCOUNTINFO_URL = `${baseURL}/freelancer/account/queryAccountInfo`; // 查询灵工账号
export const QUERY_SIGN_PREPAREINFO_URL = `${baseURL}/freelancer/contract/querySignInfo`; // 查询资质签约准备信息
export const QUERY_REALNAMEINFO_URL = `${baseURL}/freelancer/account/queryRealnameInfo`; // 查询京东账号实名信息
export const REGISTER_URL = `${baseURL}/freelancer/account/register`; // 开通灵工
export const IS_BIND_EMPLOYER = `${baseURL}/freelancer/account/isBindEmployer`; // 判断灵工是否绑定该企业
export const QUERY_ENT_NAME = `${baseURL}/freelancer/account/queryEntName`; // 查询企业名称
export const BIND_EMPLOYER = `${baseURL}/freelancer/account/bindEmployer`; // 查询企业名称
export const QUERY_SIGNINFO_URL = `${baseURL}/freelancer/contract/querySignInfo`; // 查询资质签约状态
export const SIGN_URL = `${baseURL}/freelancer/contract/sign`; // 签约
export const UPLOAD_CERTFILE_URL = `${baseURL}/freelancer/contract/uploadCertFile`; // 上传证件照片
export const QUERY_TASK_PAGINATION_URL = `${baseURL}/freelancer/task/queryTaskPagination`; // 查询任务列表
export const QUERY_TASK_URL = `${baseURL}/freelancer/task/queryTask`; // 查询任务明细
export const QUERY_SUPPORTED_SALARY_ACCOUNTINFO_URL = `${baseURL}/freelancer/account/querySupportedSalaryAccountInfo`; // 查询支持结算的账户
export const CHANGE_SALARY_ACCOUNT_URL = `${baseURL}/freelancer/account/changeSalaryAccount`; // 设置/更换结算账户
export const REFRESH_SALARY_ACCOUNT_URL = `${baseURL}/freelancer/account/refreshSalaryAccount`; // 【4.29.0】更新结算卡信息
export const QUERY_CONTRACT_PAGINATION_URL =  `${baseURL}/freelancer/contract/queryContractPagination`; // 查询资质签约合同列表（分页）
export const ACCEPT_TASK_URL = `${baseURL}/freelancer/task/acceptTask`; // 领取任务

// 佣金相关
export const QUERY_SALARYINFO_URL = `${baseURL}/freelancer/salary/querySalaryInfo`; // 查询佣金
export const QUERY_SALARY_ACCOUNTINFO_URL = `${baseURL}/freelancer/account/querySalaryAccountInfo`; // 查询结算账户
export const QUERY_SALARY_ORDER_PAGINATION_URL = `${baseURL}/freelancer/salary/querySalaryOrderPagination`; // 查询佣金记录

// 任务大厅相关
export const QUERY_FREELANCER_TASK_LIST = `${baseURL}/freelancer/task/queryFreelancerTaskList`; // 查询灵工任务列表
export const QUERY_FREELANCER_TASK_DETAIL = `${baseURL}/freelancer/task/queryFreelancerTaskDetail`; // 查询灵工任务详情
export const QUERY_TASK_DETAIL = `${baseURL}/freelancer/task/queryTaskDetail`; // 查询企业任务详情
export const ACCEPT_TASK = `${baseURL}/freelancer/task/acceptTask`; // 接收任务
export const REJECT_TASK = `${baseURL}/freelancer/task/rejectTask`; // 拒接任务
export const TASK_UPLOAD_FILE = `${baseURL}/freelancer/file/uploadFile`; // 交付上传文件
export const COMPLETE_TASK = `${baseURL}/freelancer/task/completeTask`; // 完成任务
export const QUERY_DELIVERY = `${baseURL}/freelancer/task/queryDelivery`; // 查看交付物
export const EDIT_DELIVERY = `${baseURL}/freelancer/task/editDelivery`; // 编辑交付物


// 灵工域名
export const LOCATION_BASEURL = 'http://jltk.m.jd.com';
// 外部跳转链接地址
export const LOGIN_BASEURL = '//plogin.m.jd.com/user/login.action?wxautologin=false&appid=1100&returnurl='; // 登录链接
// export const LOGOUT_BASEURL = '//plogin.m.jd.com/cgi-bin/ml/mlogout?appid=1100&returnurl='; // 退出登录跳转链接
export const LOGOUT_BASEURL = '//biz.jd.com/login/h5/exit.do?appid=1100&source=JLQYPT-H5&return='; // 退出登录跳转链接
const REALNAME_URL_PROD = '//idt.jd.com/realname-elements?channelName=956&businessReturnUrl='; // 实名跳转链接
const REALNAME_URL_DEV = '//idt-test.jd.com/realname-elements?channelName=956&businessReturnUrl='; // 实名跳转链接
export const REALNAME_BASEURL = process.env.JL_ENV === 'production' ? REALNAME_URL_PROD : REALNAME_URL_DEV;
export const REALNAME_CHANGE_BASEURL = '//idt.jd.com/realname-elements?channelName=956'; // 修改实名跳转链接
// export const REALNAME_BASEURL = '//idt.jd.com/realname-elements/?channelName=956&businessReturnUrl='; // 实名跳转链接
export const NEWCARD_BASEURL = '//msc.jd.com/card/loginpage/wcoo/toAddNewCardPage?source=15&bizType=3084&returnUrl='; // 绑卡地址

// 特殊前缀
export const outside_prefix = {
  BANK_BASE_URL: 'http://storage.360buyimg.com/payment-assets/sdk/bank/' // 银行卡logo链接前缀
}

// 注册灵工用户协议链接地址
export const register_agreements = [
  {
    url: '//static-ftcms.jd.com/p/page/5iws903yr486.htm',
    name: '京灵平台注册服务协议'
  },
  {
    url: '//static-ftcms.jd.com/p/page/bd009k7rrb8m.htm',
    name: '隐私政策'
  },
  {
    url: '//static-ftcms.jd.com/p/page/o948681xwjce.htm',
    name: '电子签章使用授权书'
  },
]

// 业务介绍页面图片
export const BUSINESS_PIC_URL = 'https://static-ftcms.jd.com/p/files/5f3394fd7d03a46c2c3eb6db.png';
// 状态码封装，使程序对状态码变化无感知————————————————————————————

// 我的证件审核状态
export const cerItemStatus = {
    'PROC': {
      code: 'PROC',
      text: '审核中'
    },
    'SUCC': {
      code: 'SUCC',
      text: '审核成功'
    },
    'AGAIN': {
      code: 'AGAIN',
      text: '重新上传'
    }
}

// 我的资质签约状态码
export const contractItemStatus = {
  // 电子合同等待签署
  'WAIT': {
    code: 'WAIT_SIGN',
    text: '等待签约',
  },
  // 电子合同签约成功
  'ESUCC': {
    code: 'SIGN_SUCCESS',
    text: '签约成功'
  },
  'PROC': {
    code: 'SIGN_PROC',
    text: '签约中',
  },
  'SUCC': {
    code: 'NORMAL',
    text: '签约成功'
  },
  'FAIL': {
    code: 'SIGN_FAIL',
    text: '签约失败'
  }
}

// 外嵌来源参数
export const jlSourceMap = {
  SYZS: 'SYZS', // 收银助手
  QM: 'QM', // 钱喵
}

// 隐藏客服电话的来源
export const noContactPhoneArr = [
  'SYZS',
  'QM',
]

// 灵工任务状态
export const taskHallListStatus = {
  // PROCESSING：进行中，COMPLETED：已完成，CANCELED：已取消，REJECTED：已拒绝
  'doing': 'PROCESSING',
  'finish': 'COMPLETED',
  'cancel': 'CANCELED',
  'reject': 'REJECTED'
}

// 文案常量——————————————————————————————————————

// 个人中心tips
export const centerTips = {
  'CERT_TODO': '待上传',
  'CERT_NORMAL': '查看上传记录',
  'CONTRACT_TODO': '待签约',
  'CONTRACT_NORMAL': '查看合同'
}

// 加载占位文案
export const defaultText = "加载中..."

// 非加密接口地址
export const noCrypto = [
  `${baseURL}/freelancer/aks/rSAPublicKeyNByAlias`, // 获取公钥
]
